import Vue from 'vue'
import { formatRange } from '@/filters/util'

function formatTemperature (t) {
  let unitTemperature = Vue.localStorage.get('unitTemperature', 'C')

  if (unitTemperature === 'F') {
    let fTemperature = (Math.round((t * 1.8 + 32) / 5) * 5).toFixed(0)
    return `${fTemperature} F`
  } else {
    return `${t} °C`
  }
}

export default function (t) {
  return formatRange(t, formatTemperature)
}
